<template lang="pug">
  b-button(:class="{'visible' : visible}", :style="position", :variant="putColor", @click="automaticScroll")
    v-icon(:name="putIcon")
</template>

<script>
const UP = 'chevron-up'
const SCROLL = 'scroll'
const INFO_COLOR = 'info'

export default {
  data() {
    return {
      offset: 300,
      element: null,
      visible: false,
      messageWatched: true,
      isDownReached: 0
    }
  },
  props: {
    element_id: {
      type: String,
      default: ''
    },
    bottom: {
      type: String,
      default: '100'
    },
    right: {
      type: String,
      default: '30'
    },
    nameIcon: {
      type: String,
      default: UP
    },
    colorButton: {
      type: String,
      default: INFO_COLOR
    },
    isScrollUp: {
      type: Boolean,
      default: true
    },
    container: {
      type: HTMLButtonElement,
      default: null
    },
    message: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    position () {
      let bottomPos = this.bottom && !isNaN(this.bottom) ? this.bottom : '100'
      let rightPos = this.right && !isNaN(this.right) ? this.right : '30'

      return {
        bottom: `${bottomPos}px`,
        right: `${rightPos}px`,
        visibility: 'hidden'
      }
    },
    putIcon() {
      return this.nameIcon ? this.nameIcon : UP
    },
    putColor() {
      return this.colorButton ? this.colorButton : INFO_COLOR
    }
  },
  methods: {
    automaticScroll() {
      let value = this.isScrollUp ? 0 : this.element.scrollHeight

      this.element.scrollTo({ top: value, behavior: 'smooth' })
    },
    scrollDown() {
      let scrollTop = this.element.scrollTop
      let scrollHeight = this.element.scrollHeight

      if (this.isScrollUp) {
        this.visible = scrollTop > this.offset
      } else {
        this.visible = scrollTop < (scrollHeight - 1000)

        if (this.container != null && !this.visible) {
          return this.putNormalStateInButton()
        }
      }
    },
    putNormalStateInButton() {
      return setTimeout(() => {
        this.messageWatched = true
        this.container.style.animation = null
        this.container.style.backgroundColor = '#ccdcff'
        this.container.style.color = 'black'
      }, 100)
    },
    putNotificationEffectInButton() {
      return setTimeout(() => {
        this.messageWatched = false
        this.container.style.animation = 'pulse 0.5s ease 0s infinite'
        this.container.style.backgroundColor = '#004fff'
        this.container.style.color = 'white'
      }, 100)
    },
  },
  mounted() {
    setTimeout(() => {
      this.isDownReached++
    }, 2000)
  
    this.$nextTick(() => {
      this.element = document.getElementById(this.element_id)

      if (this.element) {
        this.element.addEventListener(SCROLL, this.scrollDown)
      }
    })
  },
  watch: {
    message() {
      if (this.element.scrollTop > (this.element.scrollHeight - 1200)) {
        setTimeout(() => {
          try{
            this.element.scrollTo({
              top: this.element.scrollHeight, behavior: 'smooth'
            })

            this.putNormalStateInButton()
          }catch(e){

          }
        }, 100)
      }

      if (this.message.author == 'user' && this.isDownReached > 0) {
        this.putNotificationEffectInButton()
      }
    }
  },
  destroyed () {
    if(this.element) this.element.removeEventListener(SCROLL, this.scrollDown)
  },
}
</script>

<style scoped lang="scss">

</style>
